import React from 'react';
import Caret from './Caret/Caret';
import styles from './LanguageSelectionDropdown.module.css';
import { LANGUAGE_LIST } from './LanguageList';

export const COLOR = {
  white: 'white',
  blue: 'blue',
};

export const LANGUAGECODES = {
  es: 'es',
  pt: 'pt',
  en: 'en',
  ru: 'ru',
  zh: 'zh',
  nl: 'nl',
  fr: 'fr',
  tr: 'tr',
  pl: 'pl',
  za: 'za',
  my: 'my',
};

class LanguageSelectionDropdown extends React.Component {
  constructor(props) {
    super(props);
    const languageList = [...LANGUAGE_LIST];
    let currentLanguageList = [];
    this.props.languageCodes &&
      this.props.languageCodes.map((code) => {
        let array = languageList.filter((lang) => {
          return lang.code === code.toString();
        });
        currentLanguageList = [...currentLanguageList, ...array];
        return null;
      });
    this.state = {
      languageList: currentLanguageList,
      selectedLanguage: { name: '', imageUrl: '', code: '' },
      show: false,
    };
    this.container = React.createRef();
  }

  componentDidMount() {
    const { defaultLanguageCode, languageCodes } = this.props;
    const matchedArray =
      this.state.languageList &&
      this.state.languageList.filter((language) => {
        return (
          defaultLanguageCode &&
          defaultLanguageCode.toString().includes(language.code)
        );
      });
    let index = this.checkForIndex(matchedArray[0]);
    if (index > -1) {
      this.setState({
        selectedLanguage: matchedArray[0],
        languageList: this.swapArrayElements(this.state.languageList, 0, index),
      });
    }
    if (!languageCodes) {
      let array = [...LANGUAGE_LIST].filter((lang) => {
        return (
          lang.code === defaultLanguageCode &&
          defaultLanguageCode.toString().substring(0, 2)
        );
      });
      this.defaultImageUrl = array[0].imageUrl;
    }
  }

  checkForIndex = (language) => {
    let index = this.state.languageList.findIndex((lang) => {
      return lang.code === language.code;
    });
    return index;
  };

  showDropDown = () => {
    this.setState(
      (prevstate) => {
        return { show: !prevstate.show };
      },
      () => {
        this.container.current && this.container.current.focus();
      }
    );
  };

  swapArrayElements = (language, indexA, indexB) => {
    var temp = language[indexA];
    language[indexA] = language[indexB];
    language[indexB] = temp;
    return language;
  };

  selectLanguage = (language) => {
    let index = this.checkForIndex(language);
    this.setState(
      (prevstate) => {
        return {
          selectedLanguage: this.state.languageList[index],
          languageList: this.swapArrayElements(
            this.state.languageList,
            0,
            index
          ),
          show: index === 0 ? false : prevstate.show,
        };
      },
      () => {
        this.props.selectLanguage(LANGUAGECODES[language.code]);
      }
    );
  };

  render() {
    const { selectedLanguage, show, languageList } = this.state;
    const { color } = this.props;
    const type = COLOR[color];
    const isLanguageSelected =
      selectedLanguage &&
      Object.values(selectedLanguage).every((x) => x !== '');
    const renderLanguage =
      languageList &&
      languageList.map((language, index) => {
        return (
          <div
            className={styles.language}
            key={index}
            onClick={this.selectLanguage.bind(this, language)}
          >
            <span
              className={
                index === 0
                  ? `${styles.activeLanguageName} ${styles.languageName}`
                  : styles.languageName
              }
            >
              {language.name}
            </span>
            <img
              className={styles.languageImageUrl}
              src={language.imageUrl}
              alt={language.name}
            />
          </div>
        );
      });
    return (
      <div
        data-testid="languageSelectionContainer"
        className={styles.container}
        ref={this.container}
        tabIndex={0}
        onBlur={!this.defaultImageUrl && show ? this.showDropDown : () => {}}
      >
        {this.defaultImageUrl && !isLanguageSelected && (
          <div
            data-testid="disabledImageUrl"
            className={styles.disabledImageUrl}
          >
            <img src={this.defaultImageUrl} alt="Not Available" />
          </div>
        )}
        {isLanguageSelected && (
          <div className={styles.languageDropdown}>
            <div
              className={styles.selectedLanguage}
              data-testid="selectedLanguage"
            >
              <span
                onClick={this.showDropDown}
                style={{ visibility: show ? 'visible' : 'hidden' }}
                className={
                  color === COLOR['blue']
                    ? ` ${styles.selectedLanguageNameBlue} ${styles.selectedLanguageName}`
                    : `${styles.selectedLanguageName}`
                }
              >
                {selectedLanguage.name}
              </span>
              <span
                onClick={this.showDropDown}
                className={styles.selectedLanguageImage}
              >
                <img
                  src={selectedLanguage.imageUrl}
                  alt={selectedLanguage.name}
                  style={{ maxWidth: '20px' }}
                />
              </span>
              <span
                className={styles.selectedCaratIcon}
                onClick={this.showDropDown}
                style={{ visibility: show ? 'visible' : 'hidden' }}
              >
                <Caret type={type} direction="up" />
              </span>
            </div>
            {show && (
              <div className={styles.languageList} data-testid="languageList">
                {renderLanguage}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default LanguageSelectionDropdown;
